import SafeImage from '@ui/SafeImage';
import { GrayWhiteRider } from '@features/homepage';
import React from 'react';
import DirtBikeSelector from '@ui/DirtBikeSelector';

const FindPartsForYourBikeCTA = () => {
  return (
    <div className="relative isolate mb-[2rem] flex h-[35rem] flex-col items-center gap-[6.4rem] bg-[#FAFAFA] lg:w-[144rem]">
      <SafeImage
        className="absolute left-0 hidden lg:block"
        alt="decorative rider image"
        width={720}
        height={350}
        src={GrayWhiteRider}
      />
      <div className="left-0 top-0 flex h-full w-full flex-col items-center justify-evenly px-[1.6rem] lg:absolute">
        <h3 className="w-full text-center text-[2.4rem] font-semibold lg:w-auto lg:text-left lg:text-[3.2rem]">
          Find Parts For Your Bike
        </h3>
        <DirtBikeSelector />
      </div>
    </div>
  );
};

export default FindPartsForYourBikeCTA;
